import React from 'react';
import TestimonialCarousel from '../../TestimonialCarousel';

// Real, approved quotes from the public testimonials endpoint, never edited
// (marketing-content hard ban 1: no invented or reworded social proof).
// Founder, 2026-09-29: "testimonials are important. make sure everybody sees
// it." Then, the same evening: "why do we have testimonials in 2 places.. we
// can do the carousel in the top itself". So there is ONE block: every quote,
// in the carousel, right under the hero's buttons, on the first phone screen.
//
// The page fetches the quotes once and passes them in. A failed or empty
// fetch is [], and the block renders nothing: absence, never a placeholder.
// The carousel keeps one height whatever quote is showing (reserveHeight,
// long quotes clamped with a "Read more"), so the Build strip under it never
// jumps as the quotes rotate.
export default function HeroTestimonials({ testimonials }) {
    if (!(Array.isArray(testimonials) && testimonials.some((t) => t?.quote))) return null;
    return (
        <div data-testid="landing-hero-testimonials" className="mx-auto mt-4 max-w-2xl text-left">
            <h2 className="sr-only">What students and parents say</h2>
            {/* The page's own state array goes straight through: a filtered
                copy made here would be a new array every render and restart
                the carousel's clock. */}
            <TestimonialCarousel items={testimonials} reserveHeight compact />
        </div>
    );
}
